<template>
  <div id="rentComponent">
    <div v-if="withDriver">
      <AddressSelectComponent :placeHolder="$t('drive_from')" :flag="false" :rent="true" :id="'pickup-location'"
        :location-store="store.state.orderTrueDriver.pickup"
        :is-valid="store.state.orderTrueDriver.messages.validLocation.state"
        :message="store.state.orderTrueDriver.messages.validLocation.message" @getAddress="getAddress" />
      <DatepickerComponent :datepickerTranslation="$t('departure')"
        :date-store="store.state.orderTrueDriver.arrivalDate" :default-date="tomorrow"
        :is-valid="store.state.orderTrueDriver.messages.validDate.state"
        :message="store.state.orderTrueDriver.messages.validDate.message" @getDate="getDate" />

      <TimePickerComponent :modalTranslation="$t('choose_pickup_time')"
        :time-store="store.state.orderTrueDriver.arrivalTime" @getTime="getTime" />

      <PassengersComponent :passengers-store="store.state.orderTrueDriver.passengerCount"
        @getPassengers="getPassengers" />

      <template v-if="currRouteName === routesConst.HOME">
        <button :class="{ 'disabled-confirmButton': disabled, 'confirmButton': !disabled }" :disabled="disabled"
          @click="onSubmit">
          <router-link to="">{{ $t('next') }}</router-link>
        </button>
      </template>
      <template v-if="currRouteName === routesConst.SERVICES_IFRAME">
        <button :class="{ 'disabled-confirmButton': disabled, 'confirmButton': !disabled }" :disabled="disabled"
          @click="onSubmit($event, routesConst.SERVICES_IFRAME)">
          <router-link to="">{{ $t('next') }}</router-link>
        </button>
      </template>
    </div>

    <div v-if="!withDriver">

      <AddressSelectComponent id="map-pickup-end-location" :placeHolder="$t('pickup_and_return')" :flag="false"
        :rent="true" :location-store="store.state.orderFalseDriver.destination"
        :is-valid="store.state.orderFalseDriver.messages.validLocation.state"
        :message="store.state.orderFalseDriver.messages.validLocation.message" @getAddress="getAddress" />

      <DatepickerComponent :datepickerTranslation="$t('pick_up')" :pickup-date="true"
        :date-store="store.state.orderFalseDriver.pickupDate" :default-date="tomorrow"
        :is-valid="store.state.orderFalseDriver.messages.validDate.state"
        :message="store.state.orderFalseDriver.messages.validDate.message" @getDate="getDate" />

      <TimePickerComponent :modalTranslation="$t('choose_pickup_time')" :pickup-time="true"
        :time-store="store.state.orderFalseDriver.pickupTime"
        :is-valid="store.state.orderFalseDriver.messages.validTime.state"
        :message="store.state.orderFalseDriver.messages.validTime.message" @getTime="getTime" />

      <DatepickerComponent :datepickerTranslation="$t('return')" :pickup-date="false"
        :date-store="store.state.orderFalseDriver.endDate" :default-date="week"
        :is-valid="store.state.orderFalseDriver.messages.validDate.state"
        :message="store.state.orderFalseDriver.messages.validDate.message" @getDate="getDate" />

      <TimePickerComponent :modalTranslation="$t('choose_return_time')" :pickup-time="false"
        :time-store="store.state.orderFalseDriver.endTime"
        :is-valid="store.state.orderFalseDriver.messages.validTime.state"
        :message="store.state.orderFalseDriver.messages.validTime.message" @getTime="getTime" />

      <PassengersComponent :passengers-store="store.state.orderFalseDriver.passengerCount"
        @getPassengers="getPassengers" />

      <template v-if="currRouteName === routesConst.HOME">
        <button :class="{ 'disabled-confirmButton': disabled, 'confirmButton': !disabled }" :disabled="disabled"
        @click="onSubmit">
          <router-link to="">{{ $t('next') }}</router-link>
        </button>
      </template>
      <template v-if="currRouteName === routesConst.CHOOSE_VEHICLE">
        <button :class="{ 'disabled-confirmButton': disabled, 'confirmButton': !disabled }" :disabled="disabled"
          @click="onSubmit($event, routesConst.CHOOSE_VEHICLE)">
          <router-link to="">{{ $t('search') }}</router-link>
        </button>
      </template>
      <template v-if="currRouteName === routesConst.SERVICES_IFRAME">
        <button :class="{ 'disabled-confirmButton': disabled, 'confirmButton': !disabled }" :disabled="disabled"
          @click="onSubmit($event, routesConst.SERVICES_IFRAME)">
          <router-link to="">{{ $t('next') }}</router-link>
        </button>
      </template>

    </div>

  </div>

</template>

<script lang="ts">
import './Rent.scss';

import { defineComponent } from 'vue';
import { routesConst } from "../../../routes";

// @ts-ignore
import AddressSelectComponent from "../../AddressSelect/AddressSelectComponent.vue";
// @ts-ignore
import PassengersComponent from "../../Passengers/PassengersComponent.vue";
// @ts-ignore
import TimePickerComponent from "../../TimePicker/TimePickerComponent.vue";
// @ts-ignore
import DatepickerComponent from "../../Datepicker/DatePickerComponent.vue";
// @ts-ignore
import MessageComponent from "../../message/MessageComponent.vue";

import { useStore } from "vuex";
import formValidationService from '../../../services/formValidationService';
import type { ILocationStore } from "../../../store/states/ILocationStoreState.interface";
import NameOfHelper from "../../../helpers/nameOfHelper";
import { dateHelpers } from "../../../helpers/dateHelpers";
import store from "../../../store";
import type { IOrderTrueDriverState } from "../../../store/states/IOrderTrueDriverState.interface";
import type { IOrderFalseDriverState } from "../../../store/states/IOrderFalseDriverState.interface";

export default defineComponent({
  name: 'RentComponent',
  components: {
    TimePickerComponent,
    PassengersComponent,
    AddressSelectComponent,
    DatepickerComponent,
    MessageComponent
  },
  emits: ['onSearchSubmit'],
  props: {
    withDriver: {
      type: Boolean,
      required: true
    },
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
      routesConst: routesConst,
      tomorrow: dateHelpers.getDefaultDate(1),
      week: dateHelpers.getDefaultDate(7),
      currRouteName: this.$route.name,
      disabled: false,
    }
  },
  // mounted() {
    
    // Force reset order state every time this component is mounted
    // this.store.commit('orderFalseDriver/CLEAR_STATE');
    // this.store.commit('orderFalseDriver/INITIALIZE_FALSE_DRIVER_ORDER_STATE');
    // this.store.commit('orderTrueDriver/CLEAR_STATE');
    // this.store.commit('orderTrueDriver/INITIALIZE_TRUE_DRIVER_ORDER_STATE');
    // ...repeat for other modules as needed

    // Optional: If you fetch from DB, clear immediately after fetch
    // this.fetchOrderFromDB().finally(() => {
    //   this.store.commit('orderFalseDriver/CLEAR_STATE');
    //   this.store.commit('orderFalseDriver/INITIALIZE_FALSE_DRIVER_ORDER_STATE');
    // });
  // },
  // computed: {
  //   disabled() {
  //     const state = this.withDriver
  //       ? this.store.state.orderTrueDriver
  //       : this.store.state.orderFalseDriver;

  //     const location = this.withDriver
  //       ? state.pickup
  //       : state.destination;

  //     return !(location && location.country && location.place_id && location.url);
  //   }
  // },
  watch: {
    '$store.state.orderTrueDriverDates.selectedStartDate': {
      handler(newVal, oldVal) {
        this.getDate({ value: newVal, pickup: true });
      },
      // immediate: true
    }
  },

  methods: {
    getPassengers(payload: number): void {
      const action = !this.withDriver ? 'orderFalseDriver/updateState' : 'orderTrueDriver/updateState';

      this.store.dispatch(action, [{ prop: 'passengerCount', value: payload }]);
    },

    getTime(payload: { value: string, pickup: boolean }): void {
      let action = !this.withDriver ? 'orderFalseDriver/updateState' : 'orderTrueDriver/updateState';
      let prop: string | null = null;

      if (this.withDriver) {
        prop = 'arrivalTime';

        // CUSTOM ROUTE ROUTE POINT TIME UPDATE
        const routes = [...this.store.state.orderTrueDriver.customRoutes];
        routes[0].arrivalTime = payload.value;

        this.store.dispatch(action, [{ prop: 'customRoutes', value: routes }]);
      } else {
        prop = !payload.pickup ? 'endTime' : 'pickupTime';
      }

      this.store.dispatch(action, [{ prop, value: payload.value }]);
    },

    getAddress(payload: { value: ILocationStore, pickup: boolean }): void {
      const nameOf = (c) => NameOfHelper.obj(c);

      if (!this.withDriver) {
        let stateName = nameOf(() => this.store.state.orderFalseDriver);
        let state: IOrderFalseDriverState = this.store.state[stateName];

        this.store.dispatch(stateName + '/updateState', [
          { prop: nameOf(() => state.destination), value: payload.value }
        ]);

        return;
      }

      let stateName = nameOf(() => this.store.state.orderTrueDriver);
      let state: IOrderTrueDriverState = this.store.state[stateName];

      const routes = [...state.customRoutes];
      routes[0].routePoint = payload.value;

      this.store.dispatch(stateName + '/updateState', [
        { prop: nameOf(() => state.customRoutes), value: routes },
        { prop: nameOf(() => state.pickup), value: payload.value }
      ]);

    },

    getDate(payload: { value: string, pickup: boolean }): void {

      // dateHelpers.dateToDisplay(new Date(payload.value));

      let action: string = !this.withDriver ? 'orderFalseDriver/updateState' : 'orderTrueDriver/updateState';
      let prop: string | null = null;

      if (this.withDriver) {
        prop = 'arrivalDate';

        // CUSTOM ROUTE ROUTE POINT DATE UPDATE
        const routes = [...this.store.state.orderTrueDriver.customRoutes];

        // IF SOMETHING GOES WRONG WITH CUSTOM ROUTES (LIKE LENGTH === 0) THEN INIT THEM
        // if (routes.length) {
        //   store.commit('orderTrueDriver/INIT_TRUE_DRIVER_CUSTOM_ROUTES');
        //   // store.commit('orderTrueDriver/INITIALIZE_TRUE_DRIVER_ORDER_STATE');
        // }

        routes[0].arrivalDate = dateHelpers.dateToDisplay(new Date(payload.value));

        this.store.dispatch(action, [{ prop: 'customRoutes', value: routes }]);
      } else {
        prop = !payload.pickup ? 'endDate' : 'pickupDate';
      }

      this.store.dispatch(action, [{ prop, value: payload.value }]);
    },


    // TODO ADDITIONAL REFACTOR VALIDATION ADAPT FOR ALL CASES

    onSubmit(event, route?: routesConst | undefined): void {
      const nameOf = (c) => NameOfHelper.obj(c);

      const withDriver = this.withDriver;

      const stateName = !withDriver ? 'orderFalseDriver' : 'orderTrueDriver';
      const state = !withDriver ? this.store.state.orderFalseDriver : this.store.state.orderTrueDriver;

      let isDateTimeValid = true;

      const isLocationValid = formValidationService.validateRentLocation(withDriver, this.store);

      if (!withDriver) {
        isDateTimeValid = formValidationService.validateRentDateTime(state);

      } else {
        state.messages!.validDate.state = true;

        // DATE VALIDATION
        const arrivalDateInMs = new Date(new Date(state.arrivalDate).toDateString()).getTime();

        const today = new Date();
        const tomorrow = new Date().setDate(today.getDate() + 1);
        const tomorrowInMs = new Date((new Date(tomorrow).toDateString())).getTime();

        if (arrivalDateInMs < tomorrowInMs) {
          state.messages!.validDate.state = false;
          isDateTimeValid = false;
        }
      }

      const isValid = isDateTimeValid && isLocationValid;

      this.store.dispatch(
        stateName + '/updateState',
        [{ prop: nameOf(() => state.isRentFormValid), value: isValid }]
      );

      if (isValid) {
        if (route) {
          switch (route) {
            case routesConst.CHOOSE_VEHICLE:
              this.$emit('onSearchSubmit');
              return;

            case routesConst.SERVICES_IFRAME:
              const stateToSend = { ...state };
              delete stateToSend.defaultState;

              const orderStateToSend = {
                'withDriver': this.store.state.order.withDriver,
                'roundTrip': this.store.state.order.roundTrip,
                'serviceType': this.store.state.order.serviceType,
              };

              const payload = { stateName, state: stateToSend, orderState: orderStateToSend };

              const url = store.getters.appUrl + '?state=' + btoa(encodeURIComponent(JSON.stringify(payload)));

              parent.postMessage("redirect::" + url, "*");
              return;
          }

          throw new Error('Missing route handling');
        }

        this.$router.push(!withDriver ? routesConst.CHOOSE_VEHICLE : routesConst.CHOOSE_CUSTOM_ROUTE);
      }
    },
  },
  created(): void {
    // ...
  },
});

</script>

<style lang="scss">
@import "../../../../sass/variables";
</style>